/**
 * ShotChartDrawer — wraps the existing ShotChartOverlay in a v2-styled
 * Dialog so the new screen can keep using the proven FIBA-zone court
 * interaction without rewriting it.
 *
 * The wrapper is intentionally thin — it only restyles the surface and
 * forwards props. All zone detection logic stays in
 * cantera/components/ShotChartOverlay.
 */

import React from 'react';
import { Dialog, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ShotChartOverlay from '../../components/ShotChartOverlay';
import { useStatsTheme } from '../theme/statsTheme';

export default function ShotChartDrawer({
  open,
  onClose,
  shotChartAction,
  onShotRecorded,
  existingShots = [],
  t,
}) {
  const theme = useStatsTheme();
  const tt = (key, fallback) => (typeof t === 'function' ? t(`estadisticasNew.${key}`, { defaultValue: fallback }) : fallback);

  if (!shotChartAction) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: theme.surfaces.elevated,
          color: theme.text.primary,
          border: `1px solid ${theme.accentBorder}`,
          borderRadius: theme.radius.xl,
          boxShadow: theme.shadows.lg,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, borderBottom: `1px solid ${theme.surfaces.divider}` }}>
        <Box>
          <Typography sx={{ fontSize: 11, color: theme.text.secondary, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
            {tt('shotLocation', 'Where was the shot taken?')}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: theme.text.primary }}>
            {shotChartAction.player?.nom} · {shotChartAction.actionCode}
          </Typography>
        </Box>
        <IconButton onClick={onClose} aria-label="close" sx={{ color: theme.text.secondary }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ p: 2, backgroundColor: theme.surfaces.base }}>
        <ShotChartOverlay
          onShotRecorded={onShotRecorded}
          onClose={onClose}
          playerName={shotChartAction.player?.nom}
          actionCode={shotChartAction.actionCode}
          made={shotChartAction.made}
          existingShots={existingShots}
        />
      </Box>
    </Dialog>
  );
}
